import React, { useCallback } from "react";
import { SearchOutlined } from "@ant-design/icons";
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Typography,
  Button,
  Divider,
  Space,
  Descriptions,
} from "antd";
import { BOM } from "../../../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";

const { Text, Title } = Typography;

const DetailsDepositForm = (props) => {
  const {
    formData,
    accountLinkingOptions,
    customerDetail,
    productData,
    onChangeProduct,
    loanOfficerOptions,
    fundOptions,
    loanPurposeOptions,
    onFinish,
    form,
    customerInfo,
    onSearch,
    handleSearchInTable,
    showDetailsForm,
    termFrequencyTypeOptions,
  } = props;

  const items = [
    {
      label: labelConfig.customerType,
      children: customerInfo ? customerInfo.entityType : "-",
    },
    {
      label: labelConfig.customerName,
      children: customerInfo ? customerInfo.entityName : "-",
    },
    {
      label: labelConfig.mobileNumber,
      children: customerInfo ? customerInfo.entityMobileNo : "-",
    },
    {
      label: labelConfig.customerNumber,
      children: customerInfo ? customerInfo.entityAccountNo : "-",
    },
  ];

  return (
    <Form initialValues={formData} form={form} layout="vertical" onFinish={onFinish}>
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.customerInfo}
          </Title>
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Space.Compact
            style={{
              width: "100%",
            }}
          >
            <div>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Client:  Number / Mobile Number"
                style={{ width: 400 }}
                allowClear
              />
            </div>
            <Button type="primary" className="of-primaryBtnColor" onClick={onSearch}>
              <SearchOutlined />
            </Button>
          </Space.Compact>
        </Col>
      </Row>

      {showDetailsForm && (
        <>
          <Divider />
          <Descriptions
            bordered
            column={{
              xs: 1,
              sm: 2,
              md: 2,
              lg: 2,
              xl: 2,
              xxl: 2,
            }}
            style={{ marginTop: 10, marginBottom: 20 }}
            items={items}
          />

          <Row style={{ justifyContent: "space-between" }}>
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.product}
                name="productId"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.product),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg(`${labelConfig.product}`, "select")}
                  onChange={onChangeProduct}
                  options={productData}
                  showSearch
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.loanOfficer} name="loanOfficerId">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg(`${labelConfig.loanOfficer}`, "select")}
                  options={loanOfficerOptions}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.loanPurpose} name="loanPurposeId">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg(`${labelConfig.loanPurpose}`, "select")}
                  options={loanPurposeOptions}
                  showSearch
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.fund} name="fundId">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg(`${labelConfig.fund}`, "select")}
                  options={fundOptions}
                  showSearch
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.principal}
                name="principal"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.principal),
                  },
                ]}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.principal)}
                  value={1000}
                  className="of-bold-disable-input"
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.loanTerm}
                name="loanTermFrequency"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.loanTerm),
                  },
                ]}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.loanTerm)}
                  className="of-bold-disable-input"
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>{labelConfig.loanTermFrequency}</Text>}
                name="loanTermFrequencyType"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg(`${labelConfig.loanTerm}`, "select")}
                  options={termFrequencyTypeOptions}
                  showSearch
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.submittedOn}
                name="submittedOnDate"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.submittedOn),
                  },
                ]}
              >
                <DatePicker
                  placeholder={BOM.handlePlaceholderMsg(`${labelConfig.submittedOn}`, "select")}
                  style={{
                    width: "100%",
                    height: 35,
                  }}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.disbursementOn}
                name="expectedDisbursementDate"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.disbursementOn),
                  },
                ]}
              >
                <DatePicker
                  placeholder={BOM.handlePlaceholderMsg(`${labelConfig.disbursementOn}`, "select")}
                  style={{
                    width: "100%",
                    height: 35,
                  }}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <div></div>
            </Col>
          </Row>

          <Row>
            {/* <Divider style={{ marginTop: 10, marginBottom: 30 }} title=/>s */}
            <Divider orientation="left" orientationMargin="0">
              {labelConfig.savingsLinkage}
            </Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.linkSavings} name="linkAccountId">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg(`${labelConfig.linkSavings}`, "select")}
                  options={accountLinkingOptions}
                  showSearch
                />
              </Form.Item>
            </Col>

            {accountLinkingOptions.length !== 0 && (
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.createStandingInstruction}
                  name="createStandingInstructionAtDisbursement"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(`${labelConfig.option}`, "select")}
                    options={staticConfig.yesOrNoData}
                    showSearch
                  />{" "}
                </Form.Item>
              </Col>
            )}
          </Row>
        </>
      )}
    </Form>
  );
};

export default DetailsDepositForm;
